import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BASE_URL } from "../../constants";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import ContactForm from "../../components/ContactForm/ContactForm";
const Financials = () => {
  return (
    <>
      <Header />
      <Container fluid>
        {/* Heading 1 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h1 className="heading1">Helping</h1>
          </Col>
        </Row>

        {/* Heading 2 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h2 className="heading2">
              Financial <br />
              Institutions
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="text-center">
            <h1 className="heading3">Drive Sustainable Investments</h1>
          </Col>
        </Row>

        {/* First Grid */}
        <div>
          <Row className="justify-content-center align-items-end">
            {" "}
            {/* Add align-items-end here */}
            <Col md={4} className="left-box">
              <div className="leftboxtext">
                As the world moves toward a more sustainable and resilient
                future, financial institutions play a critical role in funding
                impactful projects and managing emerging risks. However,
                assessing the long-term financial viability and environmental
                impact of investments requires data-driven insights. Dsider
                empowers banks, asset managers, and investors with advanced
                simulations, carbon analytics, and risk modeling to make
                smarter, more sustainable financial decisions—driving both
                profitability and positive change.{" "}
              </div>
            </Col>
            <Col md={8} className="d-flex align-items-end">
              {" "}
              {/* Add d-flex and align-items-end here */}
              <img
                src={`${BASE_URL}solutions/financials.png
`}
                alt="Climate Tech"
                className="right-image"
              />
            </Col>
          </Row>
        </div>

        {/* Second Grid */}
        <div className="container " style={{ marginTop: "6rem" }}>
          <Row className="d-flex justify-content-center align-items-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/digital_twin_ simulations.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Enhance Sustainable Investment Decisions{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Compare multiple investment strategies for sustainable
                  projects.{" "}
                </li>
                <li>
                  Model different regulatory, market, and climate scenarios
                  before committing capital.{" "}
                </li>
                <li>
                  Optimize portfolio strategies to align with ESG and Net Zero
                  commitments.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/carbon_footprint.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Assess Climate Risks with Advanced Risk Analysis
              </h3>
              <ul className="innovation-list">
                <li>
                  Identify financial and operational risks in carbon-intensive
                  industries.{" "}
                </li>
                <li>
                  Quantify potential impacts of climate policies on investment
                  portfolios.
                </li>
                <li>
                  Mitigate exposure to high-risk assets and align with
                  sustainable finance principles.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/cost_benefit_ analysis.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Measure Carbon Impact with Carbon Abatement Analysis{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Comprehensive carbon footprint analysis of businesses and
                  projects.
                </li>
                <li>
                  Tools to assess emissions reduction strategies for loan and
                  investment portfolios.
                </li>
                <li>
                  Science-backed insights to align with green finance
                  regulations and ESG frameworks.{" "}
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/complex_datasets.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Seamless Data Integration for Smarter Financial Insights{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Real-time consolidation of climate, financial, and operational
                  data.{" "}
                </li>
                <li>
                  AI-powered analytics to enhance risk management and
                  sustainability reporting.{" "}
                </li>
                <li>
                  Compliance tracking with evolving regulatory frameworks.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>
        </div>

        {/* Action Box */}
        <Row className="justify-content-center">
          <Col
            className="action-box"
            style={{
              display: "grid",
              gridTemplateRows: "auto 1fr",
              alignItems: "start",
              justifyItems: "start",
            }}
          >
            <h4 className="action-heading">
              Make Smarter,
              <br />
              More Sustainable <br /> Financial Decisions <br /> with Dsider{" "}
            </h4>
            <p
              className="action-textFinancials"
              // style={{ justifySelf: "end", alignSelf: "end" }}
            >
              With Dsider, financial institutions can move beyond traditional
              risk assessments and gain data-driven insights into the future of
              sustainable investing and lending. Whether you're financing
              renewable energy projects, assessing corporate ESG risks, or
              aligning with Net Zero targets, our platform provides the clarity,
              confidence, and accuracy needed to make impactful decisions.
            </p>
          </Col>
        </Row>
      </Container>
      <ContactForm showFooter={false}/>
      <NewFooter />
    </>
  );
};

export default Financials;
